<app-data-table [dataTable]="dataTable" (onRowClick)="onRowClick($event)" [canFilterByAssetType]="true" dataTableKey="telemetry-table"> </app-data-table>
